<template>
  <v-card>
    <v-toolbar class="theme elevation-0 " dark>

      <v-toolbar-title>Settings</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-toolbar>

    <v-list dense>
      <div :key="i" v-for="(card, i) in cards">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <v-icon class="theme-text mb-1 mr-1" small>{{ card.icon }}</v-icon>
              {{ card.heading }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon small color="grey lighten-1">
                      info
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ card.desc }}</span>
              </v-tooltip>

            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn depressed small class="dark action-text " @click="redirect(card.path)">
               more
              <v-icon x-small class="ml-2">navigate_next</v-icon> 
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="i < cards.length - 1" />
      </div>
    </v-list>
  </v-card>

</template>

<script>
import { Component } from "@/views/component";

export default {
  name: Component.Protected.Company.SettingList,
  data: () => ({
    cards: [
      { icon: 'place', heading: 'Location settings', desc: 'Manage your offices and locations', path: Component.Protected.Company.Locations.List },
      { icon: 'receipt_long', heading: 'Department settings', desc: 'Manage your departments', path: Component.Protected.Company.Departments.List },
      { icon: 'card_giftcard', heading: 'Benefit settings', desc: 'Manage your company benefits', path: Component.Protected.Company.Benefits.List },
      { icon: 'beach_access', heading: 'Timeoff policy manager', desc: 'Create and manage timeoff policies', path: Component.Protected.Company.LeaveTypes.List },
      { icon: 'rule', heading: 'Workflow manager', desc: 'Manage onboarding, offboarding and other recurring activities', path: Component.Protected.Company.Workflow.List },
      { icon: 'calendar_today', heading: 'Calendar settings', desc: 'Add and edit company calendars and public holidays', path: Component.Protected.Company.Calendar.List },
      { icon: 'keyboard', heading: 'Backoffice manager', desc: 'Manage shared documents such as handbooks and policies', path: Component.Protected.Backoffice.List },
      { icon: 'local_offer', heading: 'Marketplace manager', desc: 'Promote your products & company on the marketplace', path: Component.Protected.Benefit.Provider.Info },
      { icon: 'lock_open', heading: 'Access management', desc: 'Manage access level for you employees', path: Component.Protected.Company.Access.List },
      { icon: 'waves', heading: 'Workflow manager', desc: 'Oversee tasks of initiated workflows', path: Component.Protected.Company.WorkflowToDos.List },
      { icon: 'card_membership', heading: 'Membership settings', desc: 'Payment and membership details', path: Component.Protected.Company.Membership.List }
    ]
  }),
  methods: {
    redirect(path) {
      if (path) this.$router.push({ name: path })
    }
  },
};
</script>
